import React from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../DropdownMenu/DropdownMenu';

export function StudyBrowserViewOptions({ tabs, onSelectTab, activeTabName }: withAppTypes) {
  const handleTabChange = (tabName: string) => {
    onSelectTab(tabName);
  };

  const activeTab = tabs.find(tab => tab.name === activeTabName);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex h-7 w-full items-center justify-between rounded-lg bg-card px-2.5 text-[12px] text-white/80 ring-1 ring-primary/20 transition-all duration-150 hover:bg-accent hover:ring-primary/40 focus:outline-none data-[state=open]:ring-primary/50">
        <span className="truncate">{activeTab?.label}</span>
        <svg className="ml-1.5 h-3 w-3 shrink-0 text-white/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[140px]">
        {tabs.map(tab => {
          const { name, label, studies } = tab;
          const isActive = activeTabName === name;
          const isDisabled = !studies.length;

          if (isDisabled) {
            return null;
          }

          return (
            <DropdownMenuItem
              key={name}
              className={isActive ? 'text-secondary font-medium' : 'text-white/80'}
              onSelect={() => handleTabChange(name)}
            >
              {isActive && (
                <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary" />
              )}
              {label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
